<div class="p-2">
    <h4 class="text-white pb-2">{{ data.title }}</h4>
    <p class="text-white pb-3">{{ data.message }}<span class="dots"></span></p>
    <mat-progress-bar mode="determinate" [value]="data.progress"></mat-progress-bar>
</div>